import Marquee from "react-fast-marquee";

export const EditorialMarquee = () => {
  return (
    <section className="relative py-16 md:py-20 bg-paper border-t border-b border-ink/10 overflow-hidden">
      <Marquee gradient={false} speed={38} pauseOnHover>
        <span className="font-display text-[13vw] md:text-[9vw] leading-none text-ink whitespace-nowrap flex items-center">
          <span className="mr-10">Making invisible businesses</span>
          <span className="italic text-teal mr-10">visible.</span>
          <span className="text-stroke mr-10">Making invisible businesses</span>
          <span className="italic text-teal mr-10">visible.</span>
        </span>
      </Marquee>
    </section>
  );
};
